import styled from 'styled-components';

import { css } from '@notino/react-styleguide';

const RowWrapper = styled.div<{ newPdDesign: boolean }>`
  ${({ newPdDesign }) =>
    !newPdDesign &&
    css`
      margin: 0 -0.9375rem;
    `}
`;

export default RowWrapper;
